import React from 'react'
import { Trans, t } from '@lingui/macro'

import UserDetail from '../../../components/common/user/user-detail/UserDetail'
import { Tags } from '../../../components/common/tag/Tags'
import { IUser } from '../types'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import Select from '../../../components/common/select/Select'

import { Dropdown } from '../../../components/common/dropdown/Dropdown'
import IconClose from '../../../components/common/icon/IconClose'
import IconSettings from '../../../components/common/icon/IconSettings'

import './Item.less'
import { Flex, LinkBox } from 'front-end/src/components'
import { css } from '@emotion/react'
import { UserGroupRoleEnum } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'

interface IProps {
  user: IUser
  groupId: number
  userClick: (event) => void
  onRemoveClick: (userId, groupId) => void
  onRoleChange: (role: UserGroupRoleEnum) => void
  onRemoveFromOtherGroup: (userId: number, groupId: number) => void
}

const getUserGroupRoles = () => [
  {
    label: t`Group administrator`,
    value: UserGroupRoleEnum.ADMIN
  },
  {
    label: t`Group member`,
    value: UserGroupRoleEnum.MEMBER
  }
]

export const GroupListItem = (props: IProps) => {
  const { user, groupId, userClick, onRemoveClick, onRoleChange } = props
  const userGroupRoles = getUserGroupRoles()
  const { theme } = useLooopTheme()
  return (
    <LinkBox
      onClick={userClick}
      className="ListItem"
      css={css`
        .Dropdown__content {
          right: 58% !important;
        }
      `}
    >
      <UserDetail
        display_name={user.display_name}
        imageUrl={user.image_url}
        meta={user.userIdentity}
        size={'normal'}
      />
      <div className="ListItem-groups">
        <Tags
          items={user.groups}
          onRemove={({ id: targetGroupId }) =>
            onRemoveClick(user.id, targetGroupId)
          }
          onClick={({ id }) => navigateTo(linkBuilder.groupDetail(id))}
        />
      </div>
      <div>
        <Select
          aria-label={t`Role select:`}
          options={userGroupRoles}
          value={userGroupRoles.find(({ value: roleValue }) => {
            return roleValue === user.userGroup.role
          })}
          // @ts-expect-error 9/11/2020
          onChange={({ value }) => {
            onRoleChange(value)
          }}
          className="roleSelect"
        />
      </div>
      <Flex justify="center" className="ListItem-actions" width="105px">
        <Dropdown
          key={0}
          display="flex"
          m="0 auto"
          boxSize="32px"
          alignItems="center"
          justifyContent="center"
          _hover={{
            borderRadius: '50%',
            backgroundColor: theme.colors.grey[200]
          }}
          content={
            <div>
              <a
                className="DropdownLink"
                key={2}
                onClick={() => onRemoveClick(user.id, groupId)}
              >
                <IconClose />
                <Trans>Remove user</Trans>
              </a>
            </div>
          }
        >
          <IconSettings />
        </Dropdown>
      </Flex>
    </LinkBox>
  )
}
